import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import React from "react";
import { ChatMessagePaneBodyClient } from "~/components/common/chat/messages/ChatMessagePaneBodyClient";
import { ChatMessagePaneBodyVendor } from "~/components/common/chat/messages/ChatMessagePaneBodyVendor";
import { ChatMessagePaneHeader } from "~/components/common/chat/messages/ChatMessagePaneHeader";
import Styles from "./ChatMessagePane.module.scss";

type Props = DeepReadonly<{
	handleTemporaryUnread: (dealId: number) => Promise<void>;
	isAdmin?: boolean;
	isVendor?: boolean;
}>;

export function ChatMessagePane({
	isVendor = false,
	isAdmin = false,
	handleTemporaryUnread
}: Props) {
	const [isDisabledUnreadButton, setIsDisabledUnreadButton] =
		React.useState<boolean>(true);
	return (
		<div className={Styles.ChatMessagePane}>
			<ChatMessagePaneHeader
				handleTemporaryUnread={handleTemporaryUnread}
				isAdmin={isAdmin}
				isDisabledUnreadButton={isDisabledUnreadButton}
				isVendor={isVendor}
			/>
			{isVendor ? (
				<ChatMessagePaneBodyVendor
					setIsDisabledUnreadButton={setIsDisabledUnreadButton}
				/>
			) : (
				<ChatMessagePaneBodyClient
					setIsDisabledUnreadButton={setIsDisabledUnreadButton}
				/>
			)}
		</div>
	);
}
